import globals from "imports/globals";
import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

const component = (function () {
    gsap.registerPlugin(ScrollTrigger);

    $(document).ready(function () {
        if ($(".hero").length) {
            if (globals.debug) console.log("component-hero initialized");

            var headlineBlue = $(".headline-blue");
            var headlineRed = $(".headline-red");

            $(".hero .hero-bar, .hero .headline-blue").addClass("on");

            setTimeout(function () {
                $(".hero .hero-bar, .hero .headline-blue").removeClass("transition-lg delay-lg");
            }, 1920);

            ScrollTrigger.create({
                trigger: $(".hero-bars")[0],
                start: `top top-=${window.innerWidth / 12}`,
                end: `+=${window.innerHeight * 2}`,
                onToggle: function (_self) {
                    if (_self.isActive) {
                        headlineBlue.addClass("hidden");
                        headlineRed.removeClass("hidden");
                    } else {
                        headlineBlue.removeClass("hidden");
                        headlineRed.addClass("hidden");
                    }
                },
                // markers: true,
            });
        }
    });
})();

export default component;
